/** What a connection check can be run for. */
export const CONNECTION_CHECK_TARGETS = [
  'api_poller_secret',
  'contact_point',
  'data_sync_job',
  'data_sync_task',
  'data_sync_template',
] as const;

export const CONNECTION_CHECK_STATES = [
  'running',
  'finished',
  'failed',
] as const;

/** Outcomes of a whole check and of each of its steps. */
export const CONNECTION_CHECK_STATUSES = [
  'ok',
  'invalid_credentials',
  'access_denied',
  'no_data_access',
  'not_found',
  'unreachable',
  'partner_error',
  'invalid_config',
  'not_checkable',
] as const;

/** Findings of a passing check that a person should still read. */
export const CONNECTION_CHECK_WARNINGS = [
  'empty_result',
  'items_not_found',
  'write_not_verifiable',
  'credentials_expire_soon',
  'settings_incomplete',
] as const;

/** How often a running check is asked for its result. */
export const CONNECTION_CHECK_POLL_INTERVAL_MS = 1000;

/**
 * Longest a check may take on the API's side, its last read included. The API
 * cuts every timeout of a check so that this holds.
 */
const CONNECTION_CHECK_BUDGET_MS = 60_000;

/**
 * How long to wait for a check's result before giving up. Comfortably past the
 * API's own budget, so waiting never ends on a check that would still answer.
 */
export const CONNECTION_CHECK_TIMEOUT_MS = CONNECTION_CHECK_BUDGET_MS + 15_000;

/** Failed polls in a row that end the wait, so a single blip does not. */
export const CONNECTION_CHECK_MAX_POLL_FAILURES = 3;
